export const date_filter_tr = {
  all: "Tümü",
  oneWeek: "Son 1 Hafta",
  oneMonth: "Son 1 Ay",
  oneYear: "Son 1 Yıl",
};
